import React, {useState} from 'react';
import Home from "../components/Homepage";
import "./custompages.css";
import DateTimePicker from 'react-datetime-picker';
import AuditQuery from "./AuditQuery";

const ManualCopCheck = () => {
    const [value,onChange] = useState(new Date());
    return (
        <>
            <Home/>
            <div className="center-page">
                <div className="main-container">
                    <div className="header"><h5>Audit Query</h5></div>
                    <form className="request-manual-cop">
                        <div className="form-search">
                            <div className="row">
                                <h5 className="form-name"><b>Search</b></h5>
                            </div>
                            <div className="row input-margin-top">
                                <div className="col-md-6 p-0">
                                    <label htmlFor="CopReference" className="label-name">CoP Reference</label>
                                    <input type="text" className="form-input" name="CopReference"/>
                                </div>
                                <div className="col-md-6 p-0">
                                    <label htmlFor="RequestingEntity" className="label-name">Requesting Entity</label>
                                    <input type="text" className="form-input" name="RequestingEntity"/>
                                </div>
                            </div>
                            <div className="row input-margin-top">
                                <div className="col-md-3 p-0">
                                    <label htmlFor="from" className="label-name">From</label>
                                    <DateTimePicker className="form-date" onChange={onChange} value={value} format={"hh:mm dd-MMM-y a"}/>
                                </div>
                                <div className="col-md-3 p-0">
                                    <label htmlFor="to" className="label-name">To</label>
                                    <DateTimePicker className="form-date" onChange={onChange} value={value} format={"hh:mm dd-MMM-y a"}/>
                                </div>
                                <div className="col-md-6 p-0">
                                    <label htmlFor="RequestName" className="label-name">Request Name</label>
                                    <input type="text" className="form-input" name="RequestName"/>
                                </div>
                            </div>
                            <div className="row input-buttons">
                                <div className="col-md-6 p-0"/>
                                <div className="col-md-6 p-0">
                                    <button className="button-position check-btn">CHECH</button>
                                    <button className="button-position clear-btn">CLEAR</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                {/*<div className="main-container">*/}
                {/*    <AuditQueryTable />*/}
                {/*</div>*/}
            </div>
        </>
    );
};

export default ManualCopCheck;
